import React from 'react';
import {useState, useEffect} from 'react';
import {CheckBox, Text} from '@priority-software/priority-style-react';
import styles from '../styles/settingsPanel.module.scss';
import {SettingsPanelCol} from '../../Common/consts';
import {createDataTestId} from '../../../../../../utils/dataTestId';

type ListItemProps = {
    col: SettingsPanelCol;
    handleChange: () => void;
};

export const ListIem = ({col, handleChange}: ListItemProps) => {
    const [isChecked, setIsChecked] = useState<boolean>(col?.isDefault || col?.isChecked);
    useEffect(() => {
        setIsChecked(col?.isDefault || col?.isChecked);
    }, [col]);

    const onChange = () => {
        col.isChecked = !isChecked;
        setIsChecked(col.isChecked);
        handleChange();
    };
    return (
        <div className={styles.itemContainer} {...createDataTestId(`panel-settings-item`, false)}>
            <CheckBox
                disabled={col.isDefault}
                checked={isChecked}
                onChange={onChange}
                {...createDataTestId(`panel-settings-checkbox`, true)}
            >
                <Text skin="paragraph-2" textColor="primary-700">
                    {col.title}
                </Text>
            </CheckBox>
        </div>
    );
};
